import { Component, Inject, OnDestroy, Optional, ViewChild } from '@angular/core';
import { MENU_EXTERNAL_LINKS, MetroxTrackingLabels } from '~app/modules/generic/constants';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { NavigationApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationNavigationEventType } from '~shared/modules/application-event/constants';
import { EXTERNAL_LINKS_CAROUSEL_CONFIG } from '../../../constants/external-links-carousel-config';
import { CarouselComponent, SlidesOutputData } from 'ngx-owl-carousel-o';
import { MediaObserver } from '@angular/flex-layout';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

@Component({
  selector: 'app-external-links',
  templateUrl: './external-links.component.html',
  styleUrls: ['./external-links.component.scss']
})
export class ExternalLinksComponent implements OnDestroy {
  @ViewChild('carousel') carousel: CarouselComponent;
  private unsubscribe$ = new Subject();
  externalLinks: any;
  customCarouselOptions = EXTERNAL_LINKS_CAROUSEL_CONFIG;
  showLeftArrow = true;
  showRightArrow = true;
  isMobile = false;

  constructor(
    private applicationEventService: ApplicationEventService,
    private mediaObserver: MediaObserver,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any
  ) {
    const market = getCountryDomainCode(this.webAppBuyerRequest);
    this.mediaObserver
    .asObservable()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
      this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile) ||
        this.mediaObserver.isActive(MEDIA_ALISES.tablet);
    });
    this.externalLinks = Object.values(MENU_EXTERNAL_LINKS()[market]);
  }

  handleExternalLinkTracking(label: string) {
    this.applicationEventService.publish(
      new NavigationApplicationEvent(
        ApplicationNavigationEventType.GlobalHeaderClick,
        MetroxTrackingLabels[label]
      )
    );
  }

  onChange() {
    setTimeout(() => {
      if (this.isMobile) {
        return;
      }
      const firstSlideActive = this.carousel.slidesData[0].isActive;
      const lastSlideActive = this.carousel.slidesData[this.carousel.slidesData.length - 1].isActive;
      this.showRightArrow = !lastSlideActive;
      this.showLeftArrow = !firstSlideActive;
    });
  }

  getTranslatedData(data: SlidesOutputData) {
    if (this.isMobile) {
      return;
    }
    const { slides } = data;
    const slidesCount = slides.length;
    const linksCounnt = this.externalLinks.length;

    // @ts-ignore
    const isFirstElementVisible = slides[0].id === this.externalLinks[0].id;

    const isLastElementVisible =
      slides[slidesCount - 1].id ===
      // @ts-ignore
      this.externalLinks[linksCounnt - 1].id;

    this.showLeftArrow = !isFirstElementVisible;
    this.showRightArrow = !isLastElementVisible;
  }


  trackById(_, externalLink: any) {
    return externalLink.id;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}

